import React from "react";
import TicketCreate from "./TicketCreate";
import TicketList from "./TicketList";
import { SupportProvider } from "../../contexts/SupportContext";

const Support: React.FC = () => {
  return (
    <SupportProvider>
      <div className="flex flex-col overflow-hidden border divide-y w-full divide-gorgonzola-blue-50 rounded-xl border-gorgonzola-blue-50">
        <div className="flex flex-col justify-between w-full gap-2.5 p-4 md:p-6 md:gap-0 md:flex-row">
          <h2 className="font-bold text-closed-shutter-300">Support</h2>

          <div className="flex items-center gap-2">
            <img src="/assets/image/get-help/header-gif.gif" alt="Header Gif" className="size-6" />
            <span className="text-xs text-closed-shutter-300/70">Our support staff is available 24/7</span>
          </div>
        </div>

        <div className="flex flex-col gap-6 p-4 md:p-6">
          <TicketCreate />
          <TicketList />
        </div>
      </div>
    </SupportProvider>
  );
};

export default Support;
